export default class DocumentRecogniseStatuses {
  static ERROR = "error";

  static DONE = "done";
}
